/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConstantsService } from './api-constants.service';
import { Pagination } from '~core/models/core.models';
import {
  ReferenceCreationParams,
  ReferenceData,
  ReferenceDataListParams
} from '~core/models/reference-data.models';

@Injectable()
export class ReferenceDataService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(referenceDataId: string): Observable<ReferenceData> {
    return this._httpClient.get<ReferenceData>(
      `${this._apiConstantsService.referenceDataUrl}/${referenceDataId}`
    );
  }

  list(
    params?: ReferenceDataListParams
  ): Observable<Pagination<ReferenceData>> {
    return this._httpClient.get<Pagination<ReferenceData>>(
      this._apiConstantsService.referenceDataUrl,
      {
        params: {
          ...params,
          details: '',
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(payload: ReferenceCreationParams[]): Observable<ReferenceData[]> {
    return this._httpClient.post<ReferenceData[]>(
      this._apiConstantsService.referenceDataUrl,
      { data: payload }
    );
  }

  update(
    referenceDataId: string,
    payload: Partial<ReferenceCreationParams>
  ): Observable<ReferenceData> {
    return this._httpClient.patch<ReferenceData>(
      `${this._apiConstantsService.referenceDataUrl}/${referenceDataId}`,
      payload
    );
  }

  delete(referenceDataId: string): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.referenceDataUrl}/${referenceDataId}`
    );
  }
}
